/* eslint-disable no-param-reassign */
// eslint-disable-next-line default-param-last
export const caculateBoxList = (imgInfo = {}, canvasDom) => {
  if (!imgInfo || !imgInfo.boxLabelRetList || !imgInfo.boxLabelRetList.length || !canvasDom) {
    return null
  }
  // prevent side effect
  let boxListCopy = imgInfo.boxLabelRetList.concat().slice(0)
  // 计算宽高比
  const canvasWidth = canvasDom.width
  const canvasHeight = canvasDom.height
  let wrapperWidth = 0
  let wrapperHeight = 0
  let deltaWidth = 0
  let deltaHeight = 0
  if ((imgInfo.width / imgInfo.height) > (canvasWidth / canvasHeight)) {
    wrapperWidth = canvasWidth
    wrapperHeight = (imgInfo.height * canvasWidth) / imgInfo.width
    deltaHeight = (canvasHeight - wrapperHeight) / 2
  } else {
    wrapperHeight = canvasHeight
    wrapperWidth = (imgInfo.width * canvasHeight) / imgInfo.height
    deltaWidth = (canvasWidth - wrapperWidth) / 2
  }
  // 指示点的半径
  const targetPointRadius = 0.015
  boxListCopy = boxListCopy.filter(item => item.category || item.rootCategory)
  boxListCopy.forEach((item) => {
    item.xPosition = ((((parseFloat(item.xmax) + parseFloat(item.xmin)) / 2)
     * wrapperWidth - targetPointRadius * canvasWidth + deltaWidth) / canvasWidth).toFixed(5)
    item.yPosition = ((((parseFloat(item.ymax) + parseFloat(item.ymin)) / 2)
     * wrapperHeight - targetPointRadius * canvasWidth + deltaHeight) / canvasHeight).toFixed(5)
    item.ifHide = item.xPosition > canvasWidth || item.xPosition < 0 || item.yPosition > canvasHeight || item.yPosition < 0
    // 判断方向
    item.pointRight = item.xPosition < 0.5

    // 根据距离来伸缩线的长短
    // eslint-disable-next-line no-mixed-operators
    item.category = (item.category || item.rootCategory) && (item.category || item.rootCategory).replace(/\s/g, '') || ''
    item.textLength = item.category.length || 0
    item.connectLineLength = 22
    item.lineStyle = { width: item.connectLineLength }
    item.tagStyle = {}
    if (item.pointRight) {
      item.lineStyle.right = `${-(item.connectLineLength - 8)}px`
      item.tagStyle.left = `${item.connectLineLength}px`
    } else {
      item.lineStyle.left = `${-(item.connectLineLength - 8)}px`
      item.tagStyle.right = `${item.connectLineLength}px`
    }
  })
  // boxListCopy = avoidTagOverlay(boxListCopy)

  return boxListCopy
}
